import _implicitStylesheets from "./appDetails.css";
import _implicitScopedStylesheets from "./appDetails.scoped.css?scoped=true";
import _wdsTitledGroup from "wds/titledGroup";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-7"${3}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<div size="1:3" data-testid="app-details-version"${3}><dt type-style="body-3" class="title${0}"${2}>${"t2"}</dt><dd type-style="body-3"${3}>${"t4"}</dd></div>`;
const $fragment3 = parseFragment`<div size="1:3" data-testid="app-details-listed-on"${3}><dt type-style="body-3" class="title${0}"${2}>${"t2"}</dt><dd type-style="body-3"${3}>${"t4"}</dd></div>`;
const $fragment4 = parseFragment`<div size="1:3" data-testid="app-details-latest-release"${3}><dt type-style="body-3" class="title${0}"${2}>${"t2"}</dt><dd type-style="body-3"${3}>${"t4"}</dd></div>`;
const stc0 = {
  classMap: {
    "app-details-wrapper": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "app-details-container": true
  },
  attrs: {
    "grid": "",
    "align-items": "spread",
    "axis": "row",
    "gap": "large"
  },
  key: 3
};
const stc2 = {
  classMap: {
    "titled-group-wrapper": true
  },
  attrs: {
    "data-testid": "app-details-supported-features"
  },
  key: 10
};
const stc3 = {
  classMap: {
    "titled-group-wrapper": true
  },
  attrs: {
    "grid": "",
    "align-items": "spread",
    "axis": "row",
    "gap": "large"
  },
  key: 12
};
const stc4 = {
  attrs: {
    "size": "1:2",
    "data-testid": "app-details-package-contents"
  },
  key: 13
};
const stc5 = {
  attrs: {
    "size": "1:2",
    "data-testid": "app-details-lightning-components"
  },
  key: 15
};
const stc6 = {
  classMap: {
    "titled-group-wrapper": true
  },
  key: 17
};
const stc7 = {
  classMap: {
    "app-details-apionly-container": true,
    "titled-group-wrapper": true
  },
  attrs: {
    "grid": "",
    "align-items": "spread",
    "axis": "row",
    "gap": "large"
  },
  key: 19
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, c: api_custom_element} = $api;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.appDetailsLabels.title))]), !$cmp.isAPISolution ? api_element("dl", stc1, [$cmp.version ? api_static_fragment($fragment2, 5, [api_static_part(2, null, api_dynamic_text($cmp.appDetailsLabels.version)), api_static_part(4, null, api_dynamic_text($cmp.version))]) : null, $cmp.listedOn ? api_static_fragment($fragment3, 7, [api_static_part(2, null, api_dynamic_text($cmp.appDetailsLabels.listedOn)), api_static_part(4, null, api_dynamic_text($cmp.listedOn))]) : null, $cmp.releaseDate ? api_static_fragment($fragment4, 9, [api_static_part(2, null, api_dynamic_text($cmp.appDetailsLabels.latestRelease)), api_static_part(4, null, api_dynamic_text($cmp.releaseDate))]) : null]) : null, $cmp.supportedFeatures.length ? api_element("div", stc2, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "tooltip": $cmp.supportedFeaturesTooltip,
      "title": $cmp.supportFeaturesTitleLabel,
      "badges": $cmp.supportedFeatures
    },
    key: 11
  })]) : null, !$cmp.isAPISolution ? api_element("div", stc3, [$cmp.packageContents.length ? api_element("div", stc4, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "tooltip": $cmp.packageContentTooltip,
      "title": $cmp.appDetailsLabels.packageContents,
      "badges": $cmp.packageContents
    },
    key: 14
  })]) : null, $cmp.lightningComponents.length ? api_element("div", stc5, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "title": $cmp.appDetailsLabels.lightningComponents,
      "badges": $cmp.lightningComponents
    },
    key: 16
  })]) : null]) : null, $cmp.languages.length ? api_element("div", stc6, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "title": $cmp.appDetailsLabels.languages,
      "badges": $cmp.languages
    },
    key: 18
  })]) : null, $cmp.isAPISolution ? api_element("div", stc7, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "title": $cmp.appDetailsLabels.apiSolutions
    },
    key: 20
  })]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-imq518fd8f";
tmpl.legacyStylesheetToken = "undefined-_appDetails";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
